import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PROVIDER_GET_LIST } from 'api/utilityActionTypes';

export default async function getUtilityProviderListAction(
  { state, utilityApiClient },
  { refresh } = {},
) {
  typeCheck('refresh::Maybe Boolean', refresh);
  const utilityProviderListStatePath = ['utilityProviders', 'list'];

  if (!refresh && state.get(utilityProviderListStatePath)) {
    return {
      list: state.get(utilityProviderListStatePath),
    };
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PROVIDER_GET_LIST,
    state: state,
    onSuccess(response) {
      state.set(utilityProviderListStatePath, response.list);
      return response;
    },
  });
}
